import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/06/principle/small-room-500-hz.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [];
